export default __webpack_public_path__ + "static/media/doctor-default.84d70923.svg";